<template>
  <div data-server-rendered="true" id="__nuxt" class="bannerBox">
    <div id="__layout">
      <div id="body">
        <div class="index_body">
          <div class="head_height">
              <div class="banner_box">
              <div class="banner page_width">
                <div class="ban_top">
                  <div class="logo"></div>
                  <div class="right flex">
                    <div class="no_login" v-if="!loginTrue" @click="loginUp()">
                      登录/注册
                    </div>

                    <!--                    <div class="no_loginLeft" @click="myInformation" v-else>-->
                    <!--                      <span>我的</span>-->
                    <!--                    </div>-->
                    <div class="no_loginRight" v-if="loginTrue">
                      <span class="logout" @click="logout" v-if="loginTrue">退出</span>
                    </div>
                  </div>
                </div>
                <div class="ban_btn">
                  <!--                  <div class="btn1" @click="existingEvidence()">我要存证</div>-->
                  <!--                  <div style="width: 10%"></div>-->
                  <!--                  <div class="btn2" @click="queryHashSslect()">我要查询</div>-->
                  <div class="btn2" @click="hisShowChange">历史申报记录</div>
                </div>
              </div>
            </div>
          </div>
  
          <div class="bord" v-if="hisShow">
            <div class="contentWrap">
              <div class="notice noticeNew">
                <div class="noticeIcon">
                  <i class="el-icon-warning" style="font-size: 18px;"></i>
                </div>
                <div class="noticeText">
                  <span style="font-weight: 600; margin-right: 4px;">仅供参考：</span>该项目生成报告仅作为参考，请根据实际情况进行修改和校正，务必保证申报项目的真实性
                </div>
              </div>

              <div class="processSection">
                <div class="processTitle">
                  <i class="el-icon-guide" style="margin-right: 8px; color: #2b6fff;"></i>
                  <span>项目申报操作流程</span>
                </div>

                <div class="steps">
                  <div class="step">
                    <div class="step-number">1</div>
                    <div class="step-text">
                      <i class="el-icon-user" style="margin-right: 6px; color: #2b6fff;"></i>
                      登录账号，确认申报主体信息
                    </div>
                  </div>
                  <div class="step">
                    <div class="step-number">2</div>
                    <div class="step-text">
                      <i class="el-icon-collection" style="margin-right: 6px; color: #2b6fff;"></i>
                      在上方选择本次申报的项目类型
                    </div>
                  </div>
                  <div class="step">
                    <div class="step-number">3</div>
                    <div class="step-text">
                      <i class="el-icon-edit-outline" style="margin-right: 6px; color: #2b6fff;"></i>
                      按提示完整填写申报表单并提交
                    </div>
                  </div>
                  <div class="step">
                    <div class="step-number">4</div>
                    <div class="step-text">
                      <i class="el-icon-document-checked" style="margin-right: 6px; color: #2b6fff;"></i>
                      在“历史申报记录”中查看生成报告
                    </div>
                  </div>
                </div>
                <div class="processDesc">
                  <i class="el-icon-warning" style="margin-right: 6px; color: #ff9f2b;"></i>
                  建议提前准备好单位基本信息、项目简介、联合申报单位等材料，以便一次性完成填写提交。
                </div>
              </div>

              <div class="typePicker">
                <div class="typePickerTop">
                  <div class="typePickerLabel"><i class="el-icon-collection-tag"></i> 当前申报类型</div>
                  <div class="typePickerValue">
                    {{ selectedFormLabel }}
                    <i class="el-icon-edit" style="margin-left: 8px; font-size: 12px; opacity: 0.8;"></i>
                  </div>
                </div>

                <div class="typePickerTitle">请选择您的项目申报类型：</div>

                <div class="typeOptions">
                  <div
                    v-for="item in formOptions"
                    :key="item.label"
                    class="typeOption"
                    :class="{ active: selectedFormKey === item.label }"
                    @click="selectForm(item.label)"
                  >
                    <i :class="item.icon" class="typeOptionIcon"></i>
                    <span class="typeOptionText">{{ item.label }}</span>
                  </div>
                </div>
              </div>

              <component :is="selectedForm" :currentType="selectedFormKey"></component>
            </div>
          </div>
          <div class="me" v-if="!hisShow">
            <historicalRecords/>
          </div>
          <!--          <div class="me" v-if="selectedForm === 'from1' ">-->
          <!--            <PersonalFrom/>-->
          <!--          </div>-->
          <!---下面背景图 -->
          <div style="background: #252525 ">
            <img
                src="../assets/img/c02ddf2d50ba0a9c37c54f6b278d02a.png"
                alt
                class="foot_bg"
            />
            <div class="website">
              <div class="max_wid">
                <div class="max_lef">

                  <!--                  <div class="labe2">版权所有：泰安市科学技术局</div>-->
                  <div class="labe2">
                    通讯地址：山东省泰安市省庄镇泰安市农高区花样年华景区内泰山农业科技孵化器大楼
                  </div>
                  <div class="classLabe2">
                    <div class="labe2Left">
                      主办单位：泰山科技大市场
                      <span class="view-count-footer">
                        <i class="el-icon-view"></i>
                        <span>{{ viewCount }} 浏览</span>
                      </span>
                    </div>
                    <div class="labe2Right">技术支持：0538-8265266</div>
                  </div>
                </div>
                <div class="max_rig">
                  <!--              <div class="label">服务电话：</div>-->
                  <div class="labe2">联系方式：18953878448</div>
                  <div class="labe2">邮编：271000</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="guide-video-fab" @click="openGuideVideo" title="观看操作视频">
      <i class="el-icon-video-play"></i>
      <span class="guide-video-fab__text">操作视频</span>
    </div> -->

    <el-dialog
        title="项目申报操作视频"
        :visible.sync="guideVideoVisible"
        width="860px"
        top="8vh"
        append-to-body
        destroy-on-close
        custom-class="guide-video-dialog"
        @close="handleGuideVideoClose"
    >
      <div v-if="currentGuideVideoUrl" class="guide-video-wrap">
        <video
            ref="guideVideoPlayer"
            class="guide-video-player"
            :key="currentGuideVideoUrl"
            :src="currentGuideVideoUrl"
            controls
            controlslist="nodownload"
            preload="metadata"
            playsinline
        >
          您的浏览器不支持视频播放
        </video>
        <div v-if="selectedFormLabel" class="guide-video-tip">当前申报类型：{{ selectedFormLabel }}</div>
      </div>
      <div v-else class="guide-video-empty">
        暂未配置操作视频，请将视频文件放到 public/video/ 目录，或在 formOptions 中配置 videoUrl
      </div>
    </el-dialog>
  </div>


</template>
<script>
import PersonalInformation from "./PersonalInformation .vue";
import InformationAdmin from "@/views/InformationAdmin.vue";
import PersonalFrom from "@/views/PersonalFrom.vue";
import unionFrom from "@/views/unionFrom.vue";
import HistoricalRecords from "@/views/historicalRecords.vue";
import {visit} from "@/api/http";
import {getInfo} from "@/api/login";
import {getStoredToken, promptReLogin} from "@/config/upload";

export default {
  components: {
    HistoricalRecords,
    PersonalFrom,
    unionFrom,
    xinxi: PersonalInformation,
    InformationAdmin
  },
  data() {
    return {
      viewCount:0,
      hisShow: true,
      loginTrue: '',//是否登录
      imgShow: false,
      showPage: true,
      formShow: false,
      queryHash: false,
      showInfo: false,
      certificateUrl: false,
      guideVideoVisible: false,
      defaultGuideVideoUrl: '',
      selectedForm: 'unionFrom',
      selectedFormKey: '中央引导地方发展科技资金',
      formOptions: [
        { label: '中央引导地方发展科技资金', value: 'unionFrom', icon: 'el-icon-collection' },
        // { label: '专项资金申请', value: 'unionFrom', icon: 'el-icon-coin' },
        { label: '科小创新能力提升工程', value: 'unionFrom', icon: 'el-icon-odometer' },
        { label: '山东省重点研发计划', value: 'unionFrom', icon: 'el-icon-data-line' },
        { label: '鲁渝科技合作项目', value: 'unionFrom', icon: 'el-icon-connection' },
        { label: '黄河流域协同科技创新项目', value: 'unionFrom', icon: 'el-icon-takeaway-box' },
        { label: '泰安市科技创新双十工程项目', value: 'unionFrom', icon: 'el-icon-office-building' }
      ]
    }
  },
  computed: {
    selectedFormLabel() {
      return this.selectedFormKey || '';
    },
    currentGuideVideoUrl() {
      const item = this.formOptions.find(option => option.label === this.selectedFormKey)
      if (item && item.videoUrl) {
        return item.videoUrl
      }
      return this.defaultGuideVideoUrl
    }
  },
  created() {
    this.checkLoginStatus();
    this.isIthHistory()
  },

  mounted() {
    this.initViewCount();
  },
  methods: {

    async initViewCount() {
      const pageKey = this.$route?.path || 'declaration';
      try {
        const res = await visit({ pageKey });
        const data = res && res.data !== undefined ? res.data : res;
        if (data && (data.code === 200 || data.code === 0)) {
          this.viewCount = data.data;
        } else if (typeof data === 'number') {
          this.viewCount = data;
        } else if (data && typeof data.data === 'number') {
          this.viewCount = data.data;
        }
      } catch (e) {
        console.error('浏览量上报失败', e);
      }
    },
    openGuideVideo() {
      this.guideVideoVisible = true;
      this.$nextTick(() => {
        const player = this.$refs.guideVideoPlayer;
        if (player) {
          player.currentTime = 0;
        }
      });
    },
    handleGuideVideoClose() {
      const player = this.$refs.guideVideoPlayer;
      if (player) {
        player.pause();
      }
    },
    selectForm(label) {
      if (!label) return;
      this.selectedForm = 'unionFrom';
      this.selectedFormKey = label;
    },

    isIthHistory() {
      console.log("typePath", this.$route.query.typePath)
      if (this.$route.query.typePath != null) {
        this.hisShow = false
      }
    },

    async checkLoginStatus() {
      const token = getStoredToken()
      if (!token) {
        this.loginTrue = false
        this.showPage = true
        this.$message({
          message: '您当前未登录账号，请登录或注册账号后进行申报',
          type: 'error',
          duration: 5000,
          showClose: true,
          offset: 200
        })
        return
      }

      try {
        const response = await getInfo(token)
        const body = response && response.data
        if (body && body.code === 401) {
          this.loginTrue = false
          promptReLogin()
          return
        }
        if (this.isValidUserInfo(body)) {
          this.loginTrue = true
          this.showPage = true
          return
        }
        this.loginTrue = false
        promptReLogin()
      } catch (error) {
        const errBody = error && error.response && error.response.data
        if (errBody && errBody.code === 401) {
          this.loginTrue = false
          promptReLogin()
          return
        }
        console.error('登录状态校验失败', error)
        this.loginTrue = true
        this.showPage = true
      }
    },

    isValidUserInfo(body) {
      if (!body) {
        return false
      }
      if (body.code === 200) {
        return true
      }
      if (body.user) {
        return true
      }
      if (body.data && body.data.user) {
        return true
      }
      return false
    },

    hisShowChange() {
      const token = localStorage.getItem('token')
      if (token == null) {
        this.$message({
          message: '您当前未登录账号，请登录或注册账号后进行查询',
          type: 'error',
          duration: 5000,
          showClose: true,
          offset: 200
        })
      } else {
        this.hisShow = false;
      }
    },
    //跳转登录
    loginUp() {
      this.$router.push({path: '/login', query: {type: "1"}})
    },

    logout() {
      console.log("go");
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = true;
      this.$router.push({path: '/login', query: {type: "1"}})
      // var item = sessionStorage.getItem("token");

    },
  }
}
</script>

<style scoped lang="scss">

.contentWrap {
  position: relative;
  z-index: 5;
  pointer-events: auto;
  background: #fff;
  border-radius: 16px;
  padding: 28px 32px 24px;
  box-shadow: 0 10px 30px rgba(14, 43, 109, 0.08);
}

.noticeNew {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #eef5ff;
  border: 1px solid #cfe3ff;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 18px;
}

.noticeNew .noticeIcon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #2b6fff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.noticeNew .noticeText {
  color: #2c3a55;
  font-size: 20px;
  line-height: 30px;
  text-align: left;
}

.typePicker {
  position: relative;
  z-index: 6;
  pointer-events: auto;
  background: #f7fbff;
  border: 1px solid #dbeafe;
  border-radius: 16px;
  padding: 18px 18px 16px;
  margin-bottom: 18px;
}

.typePickerTop {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.typePickerLabel {
  font-size: 18px;
  color: #5b6b82;
  padding: 6px 10px;
  background: #e9f2ff;
  border-radius: 999px;
}

.typePickerValue {
  font-size: 18px;
  color: #fff;
  background: linear-gradient(90deg, #2b6fff, #1f5bff);
  padding: 7px 14px;
  border-radius: 999px;
  box-shadow: 0 6px 16px rgba(43, 111, 255, 0.25);
}

.typePickerTitle {
  text-align: left;
  font-size: 20px;
  color: #1e2a3a;
  font-weight: 600;
  margin: 6px 0 14px;
}

.typeOptions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.typeOption {
  user-select: none;
  cursor: pointer;
  border: 1px solid #dbeafe;
  background: #fff;
  border-radius: 999px;
  padding: 10px 12px;
  font-size: 18px;
  color: #2c3a55;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(14, 43, 109, 0.04);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.typeOptionIcon {
  font-size: 18px;
  color: #2b6fff;
}

.typeOptionText {
  line-height: 1;
}

.typeOption:hover {
  border-color: #8bb7ff;
  box-shadow: 0 6px 18px rgba(14, 43, 109, 0.08);
}

.typeOption.active {
  border-color: #2b6fff;
  background: #eaf2ff;
  color: #1f5bff;
  font-weight: 600;
}

@media (max-width: 1200px) {
  .typeOptions {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .contentWrap {
    padding: 18px 16px 16px;
  }

  .typeOptions {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}


.classLabe2 {
  display: flex;

  .labe2Right {
    margin-left: 270px;
  }
}

.view-count-footer {
  display: inline-flex;
  align-items: center;
  margin-left: 16px;
  padding: 2px 10px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.06);
  font-size: 14px;
  color: #a8a8a8;

  i {
    font-size: 16px;
    margin-right: 6px;
  }
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
}

.selectedForm {
  width: 200px;
}

.formSelectDiv {
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.label {
  margin-right: 10px; /* 控制文本和选择框之间的间距 */
}

.selectClass {
  padding: 5px;
  border: 1px solid #ccc;
  width: 500px;
  font-size: 20px;
}

.bord {
  margin: 90px auto 120px;
  padding: 20px;
  max-width: 1200px;
  min-height: 300px;
  height: auto;
  border: 2px solid #ffffff; /* 边框 */
  text-align: center;
  transition: all 0.3s ease; /* 平滑过渡 */
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .spanFront {
    margin-bottom: 20px;
    font-size: 20px;
    text-align: center;
  }

  .formSelect {
    font-size: 20px !important;
  }
}

.bord:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* 添加阴影，增强浮起效果 */
}


::v-deep .subClass {
  color: #fff !important;
  background-color: #0077ff !important;
}

.closeClass {
  color: #fff;
  background-color: #ff4d4f;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
}

.bannerBox {
  width: 100%;
}

.layout {
  width: 100%;
}

::v-deep .layout {
  display: flex;
}

.banner_box {
  height: 500px;
}

.banner_box .ban_top .right .no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.banner_box .ban_top .left img {
  width: 176px;
}

.img {
  max-width: 100%;
  border: none;
}

.banner_box .ban_top .left .div2 {
  position: relative;
  margin: 0 40px 0 80px;
  padding: 12px 20px;
  border-radius: 23px;
}

.banner_box {
  background-image: url('~@/assets/img/img123.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 24px 0 190px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-around;

}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.banner_box .ban_text {
  margin: 100px 0 43px;
  font-weight: 600;
  font-size: 54px;
  color: #fff;
  line-height: 71px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  flex: none;
}

.banner_box .btn1,
.banner_box .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.ban_btn {
  margin-top: 410px;
}

.banner_box .ban_btn .btn1 {
  border-radius: 30px;
  border: 2px solid #fff;
  color: #fff;
}

.banner_box .ban_btn .btn2 {
  border-radius: 30px;
  background: #fff;
  color: #333;

}

.banner_box .ban_btn .btn1,
.banner_box .ban_btn .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.banner_box .ban_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box .step,
.step_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box {
  background: #f7f7f7;
  padding: 90px 0 100px;
}

.step_box .step .step_top {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
}

.step_box .step .step_lab {
  margin-top: 26px;
  font-weight: 400;
  font-size: 20px;
  color: #606266;
  line-height: 27px;
}

.step_box .step .step_itm {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.page_width {
  width: 1200px;
  margin-top: 100px;
}

.step_box .step {
  flex-direction: column;
}

.step_box .step .step_itm .itm_box .num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #2238c2;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 2px solid #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 27px;
  width: 15%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 40px;
  width: 10%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit span {
  color: #2238c2;
}

.reason_box .reason .cont .cont_itm {
  margin-left: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 385px;
  height: 286px;
  padding: 62px 53px 0;
  box-sizing: border-box;
  background: #f5fbfc;
  border-radius: 12px;
  font-size: 16px;
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exchange_box .exchange .ex_left .tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  margin-bottom: 50px;
}

.exchange_box .exchange .ex_left .tit span {
  color: #2238c2;
}

.exchange_box .exchange .ex_left {
  width: 75%;
}

.exchange_box .exchange .ex_left .itm img {
  width: 24px;
  height: 24px;
  margin-right: 14px;
  font-size: 16px;
}

img {
  max-width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange .ex_left .itm {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  font-size: 16px;
}

.exchange_box {
  padding: 84px 0 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../assets/img/lineImg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

img {
  width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.website {
  padding: 30px 0;
  background: #252525;
  justify-content: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
  color: #a8a8a8;
  background: #252525;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
  line-height: 1.6;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.logo {
  cursor: pointer;
  background-image: url('~@/assets/img/logn.png');
  background-size: 450px 70px;
  width: 450px;
  height: 70px;
  margin-bottom: 25px;
  position: relative;

  .view-count-badge {
    position: absolute;
    right: -100px;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 4px 12px;
    border-radius: 20px;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

    i {
      font-size: 18px;
      color: #fff;
    }
  }
}

.problem_box {
  width: 100%;
  background: #fff;
  padding: 90px 0 131px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.problem_box_inline {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 131px;
}

.problem_box_inline .pro_tit span {
  color: #009eb8;
}

.problem_box_inline .pro_tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
  text-align: center;
  margin-bottom: 80px;
}

.problem_box_inline .pro_lab {
  font-weight: 700;
  margin-bottom: 13px;
  font-size: 20px;
  color: #333;
}

.problem_box_inline .pro_cont {
  font-weight: 400;
  font-size: 18px;
  color: #666;
  line-height: 28px;
}

.mb40 {
  margin-bottom: 40px;
}


.form-container {
  max-width: 1200px;
  margin: 90px auto 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.processSection {
  margin-top: 28px;
  padding: 20px 24px 18px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #edf2ff;
}

.processTitle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-weight: 500;
  color: #1a2740;
}

.steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  padding: 22px 40px 8px;
  margin-top: 12px;
  margin-bottom: 24px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  flex: 1;
  position: relative;
}

.step:not(:last-child)::after {
  display: none;
}

/* 添加箭头 */
.step:not(:last-child)::before {
  display: none;
}

.step-number {
  width: 30px;
  height: 30px;
  background: #ffffff;
  color: #2b6fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #2b6fff;
  font-size: 18px;
  box-shadow: 0 2px 8px rgba(43, 111, 255, 0.18);
  z-index: 1;
}

.step-text {
  margin-top: 16px;
  font-size: 16px;
  line-height: 1.7;
  color: #4b5875;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
}

.processDesc {
  font-size: 18px;
  color: #8a94ad;
  text-align: left;
  font-weight: 500;
}
.form-row {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 20px;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 20px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
}

.file-upload {
  border: 1px dashed #d9d9d9;
  padding: 20px;
  text-align: center;
  background: #fafafa;
  border-radius: 4px;
}

.upload-button {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.file-info {
  font-size: 20px;
  color: #666;
  margin-top: 12px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-top: 8px;
}

.form-containerquery {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-bottom: 20px;
}

.certificate-type {
  border: 1px solid #e8e8e8;
  padding: 15px;
  margin-bottom: 20px;
}

.certificate-warning {
  color: #ff4d4f;
  font-size: 12px;
  margin-bottom: 10px;
}

.certificate-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.certificate-option {
  border: 1px solid #e8e8e8;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.certificate-option:hover {
  border-color: #40a9ff;
}

.certificate-option.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

.certificate-option img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.rights-section {
  margin-bottom: 20px;
}

.rights-grid {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.right-option {
  width: 25%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

.agreement {
  display: flex;
  align-items: center;

  margin-bottom: 20px;
  justify-content: center;

  input {
    width: 16px;
    height: 16px;
  }
}

.agreement a {
  color: #1890ff;
  text-decoration: none;
}

.submit-buttonLeft {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 25%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-buttonRight {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 10%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-button:hover {
  background: #40a9ff;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.cha_xun {
  padding: 3.5rem 18.33rem 10.42rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tips {
    font-size: 1.33rem;
    font-family: Microsoft YaHei, serif;
    font-weight: 400;
    color: #232323;
    line-height: 2.25rem;
  }
}

.cha_xun .tips {
  margin-top: 2.08rem;
  padding: 0.92rem 1.92rem 3.25rem;
  background: rgba(39, 130, 255, 0.1);
  border: 1px solid #2782ff;
  border-radius: 0.25rem;
  display: flex;
  align-items: baseline;
}

.cha_xun .tips div[data-v-71571416] {
  font-weight: 400;
  color: #232323;
  line-height: 2.25rem;
  font-size: 20px;
}

.cha_xun .input_box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cha_xun .file_hash[data-v-71571416],
.cha_xun .unified_numbering[data-v-71571416] {
  display: flex;
  align-items: center;
  margin-top: 4.25rem;
}

.cha_xun .file_hash .el-input[data-v-71571416] .el-input__inner,
.cha_xun .unified_numbering .el-input[data-v-71571416] .el-input__inner {
  border-radius: 0.25rem;
  font-size: 1.4rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.cha_xun .query[data-v-71571416] {
  cursor: pointer;
  margin-top: 5.67rem;
  padding: 1.17rem 10rem;
  display: inline-block;
  background: #2782ff;
  box-shadow: 0 0.3rem 3rem 0 rgba(29, 62, 187, 0.2);
  border-radius: 0.25rem;
  font-size: 1.67rem;
  font-weight: 700;
  color: #fff;
  line-height: 2rem;
}

.cha_xun .file_hash .filed[data-v-71571416],
.cha_xun .unified_numbering .filed[data-v-71571416] {
  display: flex;
  align-items: center;
}

.querytext {
  display: flex;
  width: 100px;
  font-size: 20px;
}

.me {
  max-width: 1200px;
  height: auto;
  margin: 90px auto 90px;
  padding: 20px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.imgSh {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10%;
  margin-top: 50px;
  margin-bottom: 50px;
}

.tipMessage {
  font-size: 20px;
}

.no_login {
  display: inline-block;
}

.label {
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}


::v-deep .labe2 {
  font-size: 16px;
}

.no_loginLeft {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.no_loginRight {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
  margin-left: 10px;
}

.el-dropdownClass {
  width: 50%;
}


.dataclass {
  font-size: 20px;
}

.submitClass {
  display: flex;
}

.el-textarea .el-input__count {
  margin-bottom: 10px !important;
}

.right-optionValue {
  width: 30%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

::v-deep .el-icon-close {
  font-size: 20px !important;
}

::v-deep .el-upload-list__item-name {
  font-size: 20px !important;
  color: #f56c6c !important;
}

::v-deep .el-upload-list__item .el-icon-upload-success {
  font-size: 20px !important;
}

.el-upload__tip {
  font-size: 20px;
}

::v-deep .el-upload-dragger {
  width: 600px !important;
}

.guide-video-fab {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 14px 10px;
  background: linear-gradient(180deg, #1890ff, #096dd9);
  color: #fff;
  border-radius: 0 12px 12px 0;
  box-shadow: 2px 0 16px rgba(24, 144, 255, 0.35);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  user-select: none;

  &:hover {
    transform: translateY(-50%) translateX(3px);
    box-shadow: 4px 0 20px rgba(24, 144, 255, 0.45);
  }

  i {
    font-size: 22px;
  }

  &__text {
    font-size: 13px;
    font-weight: 500;
    writing-mode: vertical-rl;
    letter-spacing: 2px;
  }
}

.guide-video-wrap {
  width: 100%;
}

.guide-video-player {
  display: block;
  width: 100%;
  max-height: 70vh;
  border-radius: 6px;
  background: #000;
}

.guide-video-tip {
  margin-top: 12px;
  font-size: 14px;
  color: #606266;
  text-align: center;
}

.guide-video-empty {
  padding: 40px 20px;
  text-align: center;
  color: #909399;
  font-size: 15px;
  line-height: 1.6;
}

::v-deep .guide-video-dialog {
  .el-dialog__body {
    display: block !important;
    padding: 16px 20px 24px;
  }
}
</style>
